import { render, staticRenderFns } from "./CreateOrg.vue?vue&type=template&id=1bcef72a&scoped=true"
import script from "./CreateOrg.vue?vue&type=script&lang=js"
export * from "./CreateOrg.vue?vue&type=script&lang=js"
import style0 from "./CreateOrg.vue?vue&type=style&index=0&id=1bcef72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcef72a",
  null
  
)

export default component.exports